export class InvestigationFieldValueEntity {
  public versionFieldId!: string;
  public value!: string | null;

  // Detail view fields (populated by GET /{id}/field-values)
  public id?: string;
  public fieldLabel?: string;
  public fieldType?: string;
  public isRequired?: boolean;
  public isVisibleToRequester?: boolean;
  public sortOrder?: number;
  public optionsJson?: string | null;
}
